var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container my-5"},[(_vm.getData.length)?_c('div',{staticClass:"speciesPage"},[_c('div',{staticClass:"row flex-column flex-md-row"},[_c('h4',{staticClass:"col-12 mt-3 mb-5"},[_vm._v(" "+_vm._s(_vm.plantData.laName)+" "),(_vm.plantData.redBook)?_c('b-icon',{attrs:{"icon":"book","variant":"danger"}}):_vm._e()],1),_c('div',{staticClass:"row col-12 flex-column flex-md-row"},[_c('div',{staticClass:"col-12 col-md-5 mb-4"},[_c('div',{staticStyle:{"max-width":"450px"}},[_c('ZoomImage',{attrs:{"image-url":_vm.plantData.image
                  ? _vm.plantData.image
                  : require('@/assets/profile/empty-image.jpg')}})],1)]),_c('div',{staticClass:"col-12 col-md-5 mb-4 ml-md-4"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"d-flex w-100"},[_c('div',{staticClass:"col-12 col-md-5 text-left mb-2 mb-md-0"},[_c('h5',[_vm._v(_vm._s(_vm.$t('plants_form_page_name_title')))])]),_c('div',{staticClass:"text-left col-12 col-md-7 mt-1"},[_c('p',[_c('strong',[_vm._v(" "+_vm._s(_vm.$t('plant_item_page_name_title_enName'))+" ")]),_vm._v(" "+_vm._s(_vm.plantData.enName)+" ")]),_c('p',[_c('strong',[_vm._v(" "+_vm._s(_vm.$t('plant_item_page_name_title_ruName'))+" ")]),_vm._v(" "+_vm._s(_vm.plantData.ruName)+" ")]),_c('p',[_c('strong',[_vm._v(" "+_vm._s(_vm.$t('plant_item_page_name_title_laName'))+" ")]),_vm._v(" "+_vm._s(_vm.plantData.laName)+" ")])])]),_c('div',{staticClass:"d-flex w-100 mt-3"},[_c('div',{staticClass:"col-12 col-md-5 text-left mb-2 mb-md-0"},[_c('h5',[_vm._v(_vm._s(_vm.$t('herbarium_form_page_input_genus_holotype')))])]),_c('div',{staticClass:"text-left col-12 col-md-7 mt-1"},[_c('p',[_vm._v(" "+_vm._s(_vm.plantData.holotypeId ? _vm.plantData.holotypeId : '-')+" ")])])]),_c('div',{staticClass:"d-flex w-100 mt-3"},[_c('div',{staticClass:"col-12 col-md-5 text-left mt-2 mb-md-0"},[_c('h5',[_vm._v(_vm._s(_vm.$t('plant_item_page_name_title_classification')))])]),_c('div',{staticClass:"text-left col-12 col-md-7 mt-1"},[_c('p',[_c('strong',[_vm._v(" "+_vm._s(_vm.$t('plant_item_page_name_classification_family'))+" ")]),_vm._v(" "+_vm._s(_vm.plantData.category && _vm.plantData.category.category ? _vm.plantData.category.category.laName : '-')+" ")]),_c('p',[_c('strong',[_vm._v(" "+_vm._s(_vm.$t('plant_item_page_name_classification_genus'))+" ")]),_vm._v(" "+_vm._s(_vm.plantData.category ? _vm.plantData.category.laName : '-')+" ")]),_c('p',[_c('strong',[_vm._v(" "+_vm._s(_vm.$t('plant_item_page_name_classification_species'))+" ")]),_vm._v(" "+_vm._s(((_vm.plantData.category.laName[0].toUpperCase()) + "." + (_vm.plantData.laName)))+" ")])])]),_c('div',{staticClass:"d-flex w-100 mt-3"},[_c('div',{staticClass:"col-12 col-md-5 text-left mt-2 mb-md-0"},[_c('h5',[_vm._v(_vm._s(_vm.$t('plant_item_page_synonyms_title')))])]),_c('div',{staticClass:"text-left col-12 col-md-7 mt-1"},[(_vm.plantData.synonyms)?_c('ul',{staticClass:"pl-3"},_vm._l((_vm.plantData.synonyms.split(',')),function(synonym,i){return _c('li',{key:i},[_vm._v(" "+_vm._s(synonym)+" ")])}),0):_c('p',[_vm._v("-")])])])])]),_c('div',{staticClass:"text-left col-12 my-3 ml-3 plantDescription"},[_c('p',[_c('strong',[_vm._v(" "+_vm._s(_vm.$t('plant_item_page_name_description'))+" ")]),_vm._v(" "+_vm._s(_vm.plantData.description)+" ")])]),_c('div',{staticClass:"ml-3"},[_c('VueJsonToCsv',{attrs:{"json-data":_vm.plantDataCsv,"labels":{
              English: {
                title:
                  _vm.$t('plants_form_page_name_title').toUpperCase() +
                  ' ' +
                  _vm.$t('plant_item_page_name_title_enName').toUpperCase()
              },
              Russian: {
                title:
                  _vm.$t('plants_form_page_name_title').toUpperCase() +
                  ' ' +
                  _vm.$t('plant_item_page_name_title_ruName').toUpperCase()
              },
              Latin: {
                title:
                  _vm.$t('plants_form_page_name_title').toUpperCase() +
                  ' ' +
                  _vm.$t('plant_item_page_name_title_laName').toUpperCase()
              },
              Holotype: {
                title: _vm.$t(
                  'herbarium_form_page_input_genus_holotype'
                ).toUpperCase()
              },
              Family: {
                title:
                  _vm.$t(
                    'plant_item_page_name_title_classification'
                  ).toUpperCase() +
                  ' ' +
                  _vm.$t(
                    'plant_item_page_name_classification_family'
                  ).toUpperCase()
              },
              Genus: {
                title:
                  _vm.$t(
                    'plant_item_page_name_title_classification'
                  ).toUpperCase() +
                  ' ' +
                  _vm.$t(
                    'plant_item_page_name_classification_genus'
                  ).toUpperCase()
              },
              Species: {
                title:
                  _vm.$t(
                    'plant_item_page_name_title_classification'
                  ).toUpperCase() +
                  ' ' +
                  _vm.$t(
                    'plant_item_page_name_classification_species'
                  ).toUpperCase()
              },
              Synonyms: {
                title: _vm.$t('plant_item_page_synonyms_title').toUpperCase()
              },
              Description: {
                title: _vm.$t('plant_item_page_name_description').toUpperCase()
              },
              GPS: {
                title: _vm.$t('herbarium_form_page_input_gps_label').toUpperCase()
              },
              Area: {
                title: _vm.$t(
                  'herbarium_form_page_input_area_label'
                ).toUpperCase()
              },
              Habitation: {
                title: _vm.$t(
                  'herbarium_form_page_input_habitation_label'
                ).toUpperCase()
              },
              Phenology: {
                title: _vm.$t(
                  'herbarium_form_page_input_phenology_label'
                ).toUpperCase()
              },
              Zone: {
                title: _vm.$t(
                  'herbarium_form_page_input_zone_label'
                ).toUpperCase()
              },
              Soil: {
                title: _vm.$t(
                  'herbarium_form_page_input_ground_label'
                ).toUpperCase()
              },
              Altitude: {
                title: _vm.$t(
                  'herbarium_form_page_input_elevation_label'
                ).toUpperCase()
              },
              Ridge: {
                title: _vm.$t(
                  'herbarium_form_page_input_ridge_label'
                ).toUpperCase()
              },
              ColourOfFlower: {
                title: _vm.$t(
                  'herbarium_form_page_input_colour_of_flower_label'
                ).toUpperCase()
              },
              NaturalBoundary: {
                title: _vm.$t(
                  'herbarium_form_page_input_natural_boundary_label'
                ).toUpperCase()
              },
              DateCollected: {
                title: _vm.$t(
                  'herbarium_form_page_input_datepicker_label'
                ).toUpperCase()
              },
              CatalogueNumber: {
                title: _vm.$t(
                  'herbarium_form_page_input_catalogueNumber_label'
                ).toUpperCase()
              },
              SpeicmenCollector: {
                title: _vm.$t(
                  'herbarium_form_page_input_specimentCollector_label'
                ).toUpperCase()
              },
              SpeicmenIdentifier: {
                title: _vm.$t(
                  'herbarium_form_page_input_specimentIdentifier_label'
                ).toUpperCase()
              },
              Photographer: {
                title: _vm.$t(
                  'herbarium_form_page_input_photographer_label'
                ).toUpperCase()
              },
              Tag: {
                title: _vm.$t('herbarium_form_page_input_tags').toUpperCase()
              }
            }}},[_c('b-button',{attrs:{"variant":"success"}},[_vm._v(" "+_vm._s(_vm.$t('plant_item_page_name_csv_download'))+" ")])],1)],1)]),_c('div',{staticClass:"col-12 my-3 plantMap"},[_c('Map',{attrs:{"specices-id":+_vm.speciesID,"read-only":""}})],1),_c('div',{staticClass:"text-left col-12 mt-3 pl-4"},[_c('h5',{staticClass:"pl-3"},[_vm._v(_vm._s(_vm.$t('plant_item_page_all_herbarium')))]),_c('div',{staticClass:"herbariumList"},[_c('div',{staticClass:"table-wrap"},[_c('b-table',{attrs:{"id":"herbarium-table","hover":"","items":_vm.getData,"fields":_vm.fields,"per-page":_vm.perPage,"current-page":_vm.currentPage},on:{"row-clicked":function (item) { return _vm.goTodetail(item.id); }},scopedSlots:_vm._u([{key:"head()",fn:function(data){return [_c('div',[_c('span',[_vm._v(_vm._s(_vm.$t(data.label)))])])]}},{key:"cell(image)",fn:function(row){return [_c('img',{staticClass:"plantImage",attrs:{"src":("" + (row.value))}})]}},{key:"cell(ruName)",fn:function(row){return [_c('span',[_vm._v(_vm._s(row.item.ruName))])]}},{key:"cell(enName)",fn:function(row){return [_c('span',[_vm._v(_vm._s(row.item.enName))])]}},{key:"cell(collectedDate)",fn:function(row){return [_c('span',[_vm._v(_vm._s(row.item.collectedDate))])]}},{key:"cell(phenology)",fn:function(row){return [_c('span',[_vm._v(_vm._s(row.item.phenology))])]}},{key:"table-caption",fn:function(){return [_c('b-pagination',{staticClass:"mt-4",attrs:{"per-page":_vm.perPage,"total-rows":_vm.getCount,"size":"sm","first-number":"","last-number":"","aria-controls":"herbarium-table"},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})]},proxy:true}],null,false,3360244260)})],1),(_vm.isLoading)?_c('div',{staticClass:"pb-5"},[_c('div',{staticClass:"m-auto"},[_c('b-spinner',{attrs:{"variant":"success","label":"Text Centered"}})],1)]):_vm._e()])])])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }